var _radialGradient, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTubeSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a12",
    cx: 0.66,
    fx: 0.66,
    cy: 0.3125,
    fy: 0.3125,
    gradientTransform: "scale(1.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2B7BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2B7BFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2B7BFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2B7BFF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B7BFF",
    stopOpacity: 0
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "transform-origin": "center",
    fill: "none",
    stroke: "url(#a12)",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeDasharray: "200 1000",
    strokeDashoffset: 0,
    cx: 100,
    cy: 100,
    r: 70
  }, /*#__PURE__*/React.createElement("animateTransform", {
    type: "rotate",
    attributeName: "transform",
    calcMode: "spline",
    dur: 2,
    values: "360;0",
    keyTimes: "0;1",
    keySplines: "0 0 1 1",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "transform-origin": "center",
    fill: "none",
    opacity: 0.2,
    stroke: "#2B7BFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    cx: 100,
    cy: 100,
    r: 70
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeSpinner);
export default __webpack_public_path__ + "static/media/tube-spinner.15b0c50e1a6b3969497e9d79092de7b1.svg";
export { ForwardRef as ReactComponent };